export default {
  auth: {
    access_token: null,
    token_type: null,
    expires_in: null,
    scope: null,
    __typename: 'Auth'
  }
}